import olExtent from 'ol/extent';

import getPaddedViewExtent from './getPaddedViewExtent';

export default function containsExtentWithPadding(map, extent, padding = null) {
	const viewExtent = padding ? getPaddedViewExtent(map, padding) : map.getView().calculateExtent(map.getSize());
	return olExtent.containsExtent(viewExtent, extent);
}
